var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"mw-home-card-item",attrs:{"to":_vm.path}},[_c('IconWrapper',{attrs:{"size":20,"icon":_vm.type ? _vm.icons[_vm.type] : _vm.icons.Case}}),_c('TextEllipsis',{staticClass:"mw-home-card-item-label",attrs:{"text":_vm.label}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }